export default __webpack_public_path__ + "static/media/3-3.6bfea844.mp3";